<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">Taisyklės forma</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <form @keydown.enter.prevent="submit()">
          <el-autocomplete
            v-if="fact === undefined"
            v-model="rule.jar_fact_sub_type_id"
            :items="jarFacts"
            itemvalue="value"
            itemtext="text"
            label="Faktas"
            validateKey="jar_fact_sub_type_id"
            required
            direct
          />
          <el-text-field v-else disabled v-model="fact.jar_fact_title" />

          <el-autocomplete
            :items="jarAttributes"
            itemvalue="code"
            itemtext="text"
            label="JAR atributas"
            direct
            v-model="rule.jar_attribute_id"
          />

          <el-text-field
            required
            label="Eilės numeris"
            type="number"
            v-model="rule.order_no"
          />

          <el-text-field
            required
            label="Atstovų dalis"
            v-model="rule.percentage"
          />

          <el-checkbox
            :label="'Įgaliojimo varnelė'"
            v-model="rule.fak_iga"
          />

          <el-checkbox
            :label="'Prokūros varnelė'"
            v-model="rule.fak_prok"
          />

          <el-checkbox
            :label="'KVO varnelė'"
            v-model="rule.fak_kvo"
          />
        </form>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <template>
          <el-button
            title="Atšaukti"
            :loading="loading"
            @click.native.stop="closeModal()"
            color="secondary"
          />

          <el-button
            color="primary"
            :title="this.fact ? $t('Išsaugoti') : $t('Pridėti')"
            :loading="loading"
            @click.native.stop="add()"
          />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalAddFactSignatoryRule',
  props: {
    value: Boolean,
    loading: Boolean,
    item: Object,
    fact: [Object, undefined],
    jarFacts: [],
    jarAttributes: [],
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      rule: {
        fak_iga: false,
        fak_prok: false,
        fak_kvo: false
      }
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    showModal(newValue) {
      if (newValue && this.fact) {
        this.rule = { ...this.rule, ...this.fact };
        this.rule.jar_attribute_id = parseInt(this.rule.jar_attribute_id)
        this.rule.jar_fact_sub_type_id = parseInt(this.rule.jar_fact_sub_type_id)
        this.$validator.reset()
      }
    },
  },
  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.rule = {
        fak_iga: false,
        fak_prok: false,
        fak_kvo: false
      }
      this.$validator.reset()
      this.$emit('close')
    },
    add() {
      this.$validator.validateAll().then((res) => {
        // Validate that order_no is a positive number
        if (this.rule.order_no === undefined || this.rule.order_no === null || isNaN(this.rule.order_no) || Number(this.rule.order_no) <= 0) {
          this.$root.$emit('DATA_ERROR_TEXT', this.$t('Eilės numeris turi būti teigiamas skaičius'));
          return;
        }

        // Validate that percentage is between 1 and 100
        if (
          this.rule.percentage !== undefined &&
          this.rule.percentage !== null &&
          (isNaN(this.rule.percentage) ||
            Number(this.rule.percentage) < 1 ||
            Number(this.rule.percentage) > 100)
        ) {
          this.$root.$emit('DATA_ERROR_TEXT', this.$t('Atstovų dalis turi būti nuo 1 iki 100'));
          return;
        }
        if (res) {
          this.rule.jar_fact_title = this.jarFacts.filter(item => item.value == this.rule.jar_fact_sub_type_id)[0].text || ''
          if (this.rule.jar_attribute_id) {
            this.rule.jar_attribute_title = this.jarAttributes.filter(item => item.value == this.rule.jar_attribute_id)[0].text || ''
          } else {
            this.rule.jar_attribute_title = null
          }
          this.$emit('add', this.rule)
          this.rule = {
            fak_iga: false,
            fak_prok: false,
            fak_kvo: false
          }
          this.$validator.reset()
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped></style>
